import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';


/**
 * Generated class for the GenericModalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-generic-modal',
  templateUrl: 'generic-modal.html',
})
export class GenericModalPage {
  title: string;
  message: string;
  buttons: string[];


  constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController) {
    this.title = navParams.get('title');
    this.message = navParams.get('message');
    let _buttons: string = navParams.get('buttons');
    this.buttons = JSON.parse(_buttons);

  }

  ionViewDidLoad() {
    //console.log('ionViewDidLoad GenericModalPage');
  }

  dismissModal(_button) {
    
    this.viewCtrl.dismiss(_button);
  }

}



// WEBPACK FOOTER //
// ./src/pages/generic-modal/generic-modal.ts